module.exports = {
  dimensions: {
    width: 76,
    height: 17
  },
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  optical: {
    top: 3,
    left: 8,
    right: 8,
    bottom: 3
  }
};